import {useState} from "react";

import {Spin} from "antd";

import {TransactionsGraph} from "../TransactionsGraph.jsx";
import {AntdModal} from "@/components/custom/AntdModal.jsx";
import {AntdTable} from "@/components/custom/AntdTable/AntdTable.jsx";
import {MaintenanceSwitcher} from "@/components/custom/MaintenanceSwitcher/MaintenanceSwitcher.jsx";
import {Transactions} from "@/variants/index.js";

import styles from "./TransactionsTab.module.css";

export const TransactionsTab = ({transactionsInfo, item, onTransactionsChange}) => {
	const [isModalVisible, setIsModalVisible] = useState(false);

	const [tableParams, setTableParams] = useState({
		pagination: {
			current: 1,
			pageSize: 50,
		},
	});

	const hasTransactions = transactionsInfo.tableData?.length > 0;
	const isGraphReady =
		!transactionsInfo.graphLoading &&
		transactionsInfo.graphMaintenance === transactionsInfo.graphDataMaintenance &&
		transactionsInfo.graphDataMaterial === transactionsInfo.material;

	function handleTableChange(pagination, filters, sorter) {
		setTableParams({
			pagination,
			filters,
			...sorter,
		});
	}

	function handleChange(maintenanceValue) {
		onTransactionsChange(maintenanceValue);
	}

	return (
		<>
			{hasTransactions && (
				<div className={styles.beautifulLink} onClick={() => setIsModalVisible(true)}>
					Open graph
				</div>
			)}
			<AntdTable
				tableSize={"small"}
				scroll={300}
				data={transactionsInfo.tableData}
				pagination={tableParams.pagination}
				onChange={handleTableChange}
				columns={Transactions.getTransactionsTableColumns(transactionsInfo)}
				data-testid="transactions-table"
			/>

			<AntdModal
				isModalVisible={isModalVisible}
				title={"Transaction Data"}
				destroyOnClose
				onCancel={() => setIsModalVisible(false)}
				onOk={() => setIsModalVisible(false)}>
				<MaintenanceSwitcher value={transactionsInfo.graphMaintenance} onChange={handleChange} />
				<Spin spinning={transactionsInfo.graphLoading}>
					{isModalVisible && isGraphReady && (
						<TransactionsGraph
							key={transactionsInfo.graphMaintenance}
							graphData={transactionsInfo.graphData}
							maintenance={transactionsInfo.graphMaintenance}
							createdDate={item?.created_date}
						/>
					)}
				</Spin>
			</AntdModal>
		</>
	);
};
